<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » イベント情報の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>イベント情報の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/entrance-exit-event.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 追加(更新)ボタン
        </div>
        <div class="manual-explain">
          クリックすることで編集内容が登録されます。<br>
          初回は無条件でイベント情報が追加されます。<br>
          2回目以降は施設、開催期間、募集期間のどれも変更しない場合は既存のイベント情報が更新されます。施設、開催期間、募集期間のどれかを変更した場合は新規にイベント情報が登録されますが、過去に登録したイベント情報と開催期間か募集期間が重複する場合は登録できません。<br>
          最後に追加(更新)したイベント情報が有効となります。(過去に登録したイベント情報も保存はされています)
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> 施設
        </div>
        <div class="manual-explain">
          イベントを開催する施設を選択します。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> 名称
        </div>
        <div class="manual-explain">
          名称を設定します。<br>
          編集ボタンから<a [href]="nameDialogLink">編集用ダイアログ</a>を開き設定します。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> 詳細
        </div>
        <div class="manual-explain">
          詳細を設定します。<br>
          編集ボタンから<a [href]="descDialogLink">編集用ダイアログ</a>を開き設定します。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> 画像ファイル
        </div>
        <div class="manual-explain">
          イベントのメイン画像を設定します。<br>
          ファイル追加ボタンからファイルを選択します。<br>
          ※ファイルは、<a [href]="uploaderLink">アップロードファイル画面</a>で事前にアップロードしてある必要があります。<br>
          ※言語ごとの画像設定が可能です。該当言語の画像がない場合は英語用、英語用の画像が登録されない場合は日本語用の画像が表示されます。<br>
          メイン画像は複数登録可能です。複数登録した場合、画像はスライド表示されます。<br>
          また、展示画像はドラッグ&ドロップで並び替えが可能です。<br>
          ※画像の推奨サイズ（縦横比）は以下になります。<br>
          &nbsp;&nbsp;メイン画像：1 : 1（例）高さ1400px、幅1400px
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> 開催期間
        </div>
        <div class="manual-explain">
          イベントの開催期間(開始日と終了日)を設定します。<br>
          有効となっているイベント情報の開催期間の終了日以前ならユーザー画面のメニューにエントリーフォームが表示されます。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/G.png"> 募集期間
        </div>
        <div class="manual-explain">
          イベントのエントリー募集期間(開始日と終了日)を設定します。<br>
          有効となっているイベント情報の募集期間中ならユーザー画面のエントリーフォームからイベントへのエントリーができます。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/H.png"> エントリー完了時：メール文面の設定
        </div>
        <div class="manual-explain">
          ▼エントリー完了時に送信されるメールの文面を設定します。<br>
          <br>
          メールタイトル：<span class="manual-explain-notes">※必須項目</span><br>
          ユーザーに送信するエントリー完了メールのタイトルを設定します。<br>
          メール本文（文頭）：<span class="manual-explain-notes">※必須項目</span><br>
          ユーザーに送信するエントリー完了メールの文頭に配置する文章を設定します（下記文面中★の箇所）。<br>
          メール本文（文中）：<br>
          ユーザーに送信するエントリー完了メールの文中に配置する文章を設定します（下記文面中★★の箇所）。<br>
          メール本文（文末）：<br>
          ユーザーに送信するエントリー完了メールの文末に配置する文章を設定します（下記文面中★★★の箇所）。<br>
          編集ボタンから<a [href]="sendMailMessageDialogLink">編集用ダイアログ</a>を開き設定します。<br>
          <br>
          メール本文の構成は下記となります。<br>
          ------------------------------------------------<br>
          <br>
          ★メール本文（文頭）<br>
          <br>
          イベント名 : 〇〇展<br>
          開催期間 : YYYY-MM-DD ～ YYYY-MM-DD<br>
          <br>
          ▼エントリー内容<br>
          エントリー番号 : 12345678<br>
          会社名 : 株式会社〇〇<br>
          部署 : 〇〇部<br>
          役職 : 部長<br>
          お名前 : 山田 太郎<br>
          お名前カナ : ヤマダ タロウ<br>
          メールアドレス : xxxxxxxxxxx<br>
          携帯電話番号 : 09011112222<br>
          <br>
          <br>
          施設の入退場時に下記リンク先より表示されるQRコードの提示が必要となります。<br>
          &nbsp;&nbsp;&nbsp;https://xxxxxxxxxxx/entry-qr/12345678:xxxxxxxxxxx<br>
          <br>
          ★★メール本文（文中）<br>
          <br>
          * 本メールは施設のご利用予約により自動送信しております。<br>
          * 本メールは送信専用のため、ご返信いただいてもお答えできません。ご了承ください。<br>
          <br>
          ★★★メール本文（文末）<br>
          ------------------------------------------------<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/I.png"> 入場口
        </div>
        <div class="manual-explain">
          管理対象の入場口を設定します。<br>
          入場口リストはドラッグ&ドロップで並び替えが可能です。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/J.png"> 退場口
        </div>
        <div class="manual-explain">
          管理対象の退場口を設定します。<br>
          退場口リストはドラッグ&ドロップで並び替えが可能です。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/K.png"> フロア・表示グループリスト
        </div>
        <div class="manual-explain">
          管理対象の展示を持つフロア・表示グループを設定します。<br>
          フロア・表示グループリスト追加ボタンから展示物を選択します。<br>
          ※フロア・表示グループは、<a [href]="floorDialogLink">フロア・表示グループ情報画面</a>で事前に登録してある必要があります。<br>
          フロア・表示グループリストはドラッグ&ドロップで並び替えが可能です。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/L.png"> イベント設問（基本項目：チェックありで表示）
        </div>
        <div class="manual-explain">
          エントリー時にユーザー画面に表示する基本項目の表示有無を設定します。<br>
          チェックを入れた項目が表示されます。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/M.png"> イベント設問（カスタム項目）
        </div>
        <div class="manual-explain">
          エントリー時にユーザー画面（基本項目の下）に表示するカスタム項目を選択します。<br>
          カスタム項目は、入退場管理設問機能から登録可能です。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/N.png"> イベント設問（基本項目：チェックありで出力）
        </div>
        <div class="manual-explain">
          入退場時に利用するQRコードと共に出力する基本項目の出力有無を設定します。(最大5つ)<br>
          チェックを入れた項目が出力されます。<br>
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Event Information
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Event Information</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_entrance-exit-event.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Add (Update) Button
        </div>
        <div class="manual-explain">
          Click to register the edited content.<br>
          Event information is added unconditionally for the first time.<br>
          From the second time onwards, if none of the facility, event period, or recruitment period are changed, the existing event information will be updated. If any of the facility, event period, or recruitment period are changed, new event information will be registered, but if the event period or recruitment period overlaps with previously registered event information, it cannot be registered.<br>
          The last added (updated) event information will be valid. (Previously registered event information is also saved)
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Facility
        </div>
        <div class="manual-explain">
          Select the facility where the event will be held.<br>
          <span class="manual-explain-notes">*Required field</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Name
        </div>
        <div class="manual-explain">
          Set the name.<br>
          Open the <a [href]="nameDialogLink">edit dialog</a> from the edit button to configure.<br>
          <span class="manual-explain-notes">*Required field</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Detail
        </div>
        <div class="manual-explain">
          Set the details.<br>
          Open the <a [href]="descDialogLink">edit dialog</a> from the edit button to configure.<br>
          <span class="manual-explain-notes">*Required field</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> Image Files
        </div>
        <div class="manual-explain">
          Set the main image for the event.<br>
          Select files using the Add File button.<br>
          *Files must be uploaded in advance on the <a [href]="uploaderLink">Upload Files screen</a>.<br>
          *Image settings for each language are possible. If there is no image for the corresponding language, English images will be displayed, and if no English image is registered, Japanese images will be displayed.<br>
          Multiple main images can be registered. When multiple images are registered, they will be displayed as a slideshow.<br>
          Exhibit images can also be reordered by drag & drop.<br>
          *The recommended image size (aspect ratio) is as follows:<br>
          &nbsp;&nbsp;Main image: 1:1 (Example) Height 1400px, Width 1400px
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> Event Period
        </div>
        <div class="manual-explain">
          Set the event period (start date and end date).<br>
          If it's before the end date of the active event information's event period, the entry form will be displayed in the user screen menu.<br>
          <span class="manual-explain-notes">*Required field</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/G.png"> Recruitment Period
        </div>
        <div class="manual-explain">
          Set the event entry recruitment period (start date and end date).<br>
          During the recruitment period of the active event information, users can enter the event from the entry form on the user screen.<br>
          <span class="manual-explain-notes">*Required field</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/H.png"> Entry Completion: Email Text Settings
        </div>
        <div class="manual-explain">
          ▼Set the text of the email sent upon entry completion.<br>
          <br>
          Email Title: <span class="manual-explain-notes">*Required field</span><br>
          Set the title of the entry completion email sent to users.<br>
          Email Body (Header): <span class="manual-explain-notes">*Required field</span><br>
          Set the text to be placed at the beginning of the entry completion email sent to users (★ section in the text below).<br>
          Email Body (Middle):<br>
          Set the text to be placed in the middle of the entry completion email sent to users (★★ section in the text below).<br>
          Email Body (Footer):<br>
          Set the text to be placed at the end of the entry completion email sent to users (★★★ section in the text below).<br>
          Open the <a [href]="sendMailMessageDialogLink">edit dialog</a> from the edit button to configure.<br>
          <br>
          The structure of the email body is as follows:<br>
          ------------------------------------------------<br>
          <br>
          ★Email Body (Header)<br>
          <br>
          Event Name: XX Exhibition<br>
          Event Period: YYYY-MM-DD ~ YYYY-MM-DD<br>
          <br>
          ▼Entry Content<br>
          Entry Number: 12345678<br>
          Company Name: XX Company<br>
          Department: XX Department<br>
          Job Title: Manager<br>
          Name: Taro Yamada<br>
          Name (Kana): Yamada Taro<br>
          Email Address: xxxxxxxxxxx<br>
          Mobile Phone Number: 09011112222<br>
          <br>
          <br>
          When entering/exiting the facility, you need to present the QR code displayed from the link below.<br>
          &nbsp;&nbsp;&nbsp;https://xxxxxxxxxxx/entry-qr/12345678:xxxxxxxxxxx<br>
          <br>
          ★★Email Body (Middle)<br>
          <br>
          * This email is automatically sent due to your facility usage reservation.<br>
          * This email is for sending only, so we cannot respond to your reply. Please understand.<br>
          <br>
          ★★★Email Body (Footer)<br>
          ------------------------------------------------<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/I.png"> Entrance
        </div>
        <div class="manual-explain">
          Set the entrances to be managed.<br>
          The entrance list can be reordered by drag & drop.<br>
          <span class="manual-explain-notes">*Required field</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/J.png"> Exit
        </div>
        <div class="manual-explain">
          Set the exits to be managed.<br>
          The exit list can be reordered by drag & drop.<br>
          <span class="manual-explain-notes">*Required field</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/K.png"> Floor/Display Group List
        </div>
        <div class="manual-explain">
          Set the floor/display groups with exhibits to be managed.<br>
          Select exhibits using the Add Floor/Display Group List button.<br>
          *Floor/display groups must be registered in advance on the <a [href]="floorDialogLink">Floor/Display Group Information screen</a>.<br>
          The floor/display group list can be reordered by drag & drop.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/L.png"> Event Questions (Basic Items: Displayed with Check Mark)
        </div>
        <div class="manual-explain">
          Set whether to display basic items on the user screen during entry.<br>
          Checked items will be displayed.<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/M.png"> Event Questions (Custom Items)
        </div>
        <div class="manual-explain">
          Select custom items to be displayed on the user screen (below basic items) during entry.<br>
          Custom items can be registered through the entry/exit management question function.<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/N.png"> Event Questions (Basic Items: Output with Check Mark)
        </div>
        <div class="manual-explain">
          Set whether to output basic items along with the QR code used for entry/exit. (Up to 5)<br>
          Checked items will be output.<br>
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
